import { cyan, orange } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// For custom variables in Typescript (https://mui.com/material-ui/customization/theming/#custom-variables)
declare module "@mui/material/styles" {
  interface Palette {
    amber: Palette["primary"];
    cyan: Palette["primary"];
    toolbar: Palette["primary"];
    modal: Palette["primary"];
    chip: Palette["primary"];
  }

  interface PaletteOptions {
    amber: PaletteOptions["primary"];
    cyan: PaletteOptions["primary"];
    toolbar: PaletteOptions["primary"];
    modal: PaletteOptions["primary"];
    chip: PaletteOptions["primary"];
  }
}

// Create a theme instance.
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#FFF",
    },
    secondary: {
      main: "#0d2a3e",
      light: "#49ccdf",
    },
    amber: {
      main: orange["A700"],
      light: orange["A200"],
    },
    cyan: {
      main: cyan["A700"],
    },
    toolbar: {
      main: "#00365b",
    },
    background: {
      paper: "#001f34", // Dark blue
      default: "#0E476C", // Alternatives: 49ccdf, 77d8e6, eaf1f8
    },
    modal: {
      main: "#0d2a3e",
    },
    chip: {
      main: "#001f34",
      light: "#2d8a9e",
    },
  },
  typography: {
    h1: { fontSize: "1.9rem" },
    h2: { fontSize: "1.6rem" },
    h3: { fontSize: "1.3rem", fontWeight: 400 },
    h4: { fontSize: "1.1rem", fontWeight: 450 },
  },
  components: {
    MuiLink: {
      defaultProps: {
        underline: "none",
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          "> .MuiBox-root": {
            border: "2px solid #000",
          },
        },
      },
    },
  },
});

export default theme;
